var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12C9.91875 12 8.5651 11.4125 7.43906 10.2375C6.31302 9.0625 5.75 7.65 5.75 6C5.75 4.35 6.31302 2.9375 7.43906 1.7625C8.5651 0.5875 9.91875 0 11.5 0C13.0812 0 14.4349 0.5875 15.5609 1.7625C16.687 2.9375 17.25 4.35 17.25 6C17.25 7.65 16.687 9.0625 15.5609 10.2375C14.4349 11.4125 13.0812 12 11.5 12ZM0 24V19.8C0 18.95 0.209875 18.1685 0.629625 17.4555C1.04938 16.7425 1.60617 16.199 2.3 15.825C3.78542 15.05 5.29479 14.4685 6.82812 14.0805C8.36146 13.6925 9.91875 13.499 11.5 13.5C13.0812 13.5 14.6385 13.694 16.1719 14.082C17.7052 14.47 19.2146 15.051 20.7 15.825C21.3948 16.2 21.9521 16.744 22.3718 17.457C22.7916 18.17 23.001 18.951 23 19.8V24H0Z",
    fill: "#CB6060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember);
export default __webpack_public_path__ + "static/media/member.76a3ba9775441be7de3d0768547d1279.svg";
export { ForwardRef as ReactComponent };